import { UserProfile, AccountInformation, CompanyInformation, DealerInformation, SecurityInformation } from '../types/user.types';
import axiosInstance from '../../utils/axios';



export const userService = {
  /**
   * Get the current user's profile data
   * @returns Promise with the user profile data
   */
  async getCurrentUser(): Promise<UserProfile> {
    const response = await axiosInstance.get<UserProfile>('/api/v1/users/me');
    return response.data;
  },

  /**
   * Update the current user's profile data
   * @param data The updated user profile data
   * @returns Promise with the updated user profile data
   */
  async updateCurrentUser(data: Partial<UserProfile>): Promise<UserProfile> {
    const response = await axiosInstance.patch<UserProfile>('/api/v1/users/me', data);
    return response.data;
  },

  /**
   * Update account information
   * @param accountInfo Updated account information
   * @returns Promise with the updated account information
   */
  async updateAccountInfo(accountInfo: Partial<AccountInformation>): Promise<AccountInformation> {
    const response = await axiosInstance.patch('/api/v1/users/account-infos', accountInfo);
    return response.data;
  },

  /**
   * Update company information
   * @param companyInfo Updated company information
   * @returns Promise with the updated company information
   */
  async updateCompanyInfo(companyInfo: Partial<CompanyInformation>): Promise<CompanyInformation> {
    const response = await axiosInstance.patch('/api/v1/users/company-infos', companyInfo);
    return response.data;
  },

  /**
   * Update dealer information
   * @param dealerInfo Updated dealer information
   * @returns Promise with the updated dealer information
   */
  async updateDealerInfo(dealerInfo: Partial<DealerInformation>): Promise<DealerInformation> {
    const response = await axiosInstance.patch('/api/v1/users/dealer-infos', dealerInfo);
    return response.data;
  },

  /**
   * Update username
   * @param username New username
   * @returns Promise with the updated user data
   */
  async updateUsername(username: string): Promise<{ username: string }> {
    const response = await axiosInstance.patch('/api/v1/users/me/username', { username });
    return response.data;
  },

  /**
   * Update password
   * @param currentPassword Current password for verification
   * @param newPassword New password
   * @returns Promise with success message
   */
  async updatePassword(currentPassword: string, newPassword: string): Promise<{ message: string }> {
    const response = await axiosInstance.patch('/api/v1/users/me/password', {
      currentPassword,
      newPassword
    });
    return response.data;
  },

  /**
   * Update security information
   * @param securityInfo Updated security information
   * @returns Promise with the updated user profile
   */
  async updateSecurityInfo(securityInfo: Partial<SecurityInformation>): Promise<UserProfile> {
    const response = await axiosInstance.patch('/api/v1/users/security-infos', securityInfo);
    return response.data;
  }
};
